module.exports = __webpack_public_path__ + "static/img/man_glove_6.88cf836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_6.png
// module id = Biv6
// module chunks = 0